var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { Form } from 'antd';
import { useParams, useLocation } from 'react-router-dom';
import Header from 'components/Header';
import { PageContainer, Button, Modal, Input } from 'ui/styled';
import useOrganizationGroupUpdateOrganizationsMutation from 'apollo/mutations/OrganizationGroups/ORGANIZATION_GROUP_UPDATE_ORGANIZATIONS';
import OrganizationSelect from 'components/OrganizationSelect';
import FilterSystem from 'components/FilterSystem';
import debounce from 'lodash.debounce';
import { OrganizationGroupTable } from './OrganizationGroupTable';
var Item = Form.Item;
var initialValues = {
    organizationId: ''
};
var OrganizationGroup = function () {
    var _a = useState(false), isModalOpen = _a[0], setIsModalOpen = _a[1];
    var form = Form.useForm()[0];
    var id = useParams().id;
    var location = useLocation();
    var searchParams = new URLSearchParams(location.search);
    var search = searchParams.get('search');
    var containerRef = useRef(null);
    var _b = useOrganizationGroupUpdateOrganizationsMutation({
        organization_group_ids: [id],
        first: 25,
        search: search
    }), organzationsListUpdate = _b.onMutate, organizationsListUpdateLoading = _b.loading;
    var onOrganizationAdd = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var organizationId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    organizationId = values.organizationId;
                    return [4 /*yield*/, organzationsListUpdate({
                            organization_group_id: id,
                            add_ids: [organizationId]
                        })];
                case 1:
                    _a.sent();
                    setIsModalOpen(false);
                    form.resetFields();
                    return [2 /*return*/];
            }
        });
    }); };
    var onOrganizationDelete = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, organzationsListUpdate({
                        organization_group_id: id,
                        remove_ids: [value]
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(Header, { title: "Organization Groups" }), _jsx(PageContainer, { ref: containerRef, children: _jsx(FilterSystem, { defaults: { search: null }, children: function (filterValues, updateFilters) {
                        var debouncedUpdate = debounce(updateFilters, 500);
                        return (_jsxs(_Fragment, { children: [_jsx(Button, { onClick: function () { return setIsModalOpen(true); }, type: "primary", margin: "20px 10px 10px 30px", children: "Add organization" }), _jsx(Input, { style: { width: 300 }, onChange: function (e) { return debouncedUpdate('search', e.target.value); }, placeholder: "Enter name", defaultValue: filterValues === null || filterValues === void 0 ? void 0 : filterValues.search }), _jsx("div", { style: { width: '100%' }, children: _jsx(OrganizationGroupTable, { id: id, filterValues: filterValues, onOrgDelete: onOrganizationDelete, containerRef: containerRef }) })] }));
                    } }) }), _jsx(Modal, { title: "Add Organization", open: isModalOpen, onOk: form.submit, onCancel: function () { return setIsModalOpen(false); }, children: _jsx(Form, { form: form, initialValues: initialValues, onFinish: onOrganizationAdd, children: _jsx(Item, { name: "organizationId", rules: [{ required: true, message: 'Field is required' }], children: _jsx(OrganizationSelect, { loading: organizationsListUpdateLoading }) }) }) })] }));
};
export default OrganizationGroup;
